"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _browserLogs = require("@datadog/browser-logs");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var loggerContext = {
  logger: {
    name: 'SystemHealthMonitor'
  }
};
var NOT_SUPPORTED = 'not-supported';
var SAMPLE_INTERVAL_MS = 5000; // 5 seconds
var ALERT_THRESHOLD = 60000; // 60 seconds

var SERIOUS_PRESSURE = 'serious';
var CRITICAL_PRESSURE = 'critical';
var HIGH_CPU_PRESSURE = [SERIOUS_PRESSURE, CRITICAL_PRESSURE];

/**
 * SystemHealthMonitor component to monitor system health
 * @param onProlongedHighCPUUsage
 * @returns {null}
 * @constructor
 */
var SystemHealthMonitor = function SystemHealthMonitor(_ref) {
  var _ref$onProlongedHighC = _ref.onProlongedHighCPUUsage,
    onProlongedHighCPUUsage = _ref$onProlongedHighC === void 0 ? null : _ref$onProlongedHighC;
  var alertStartTime = (0, _react.useRef)(null);
  var observer = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (observer.current) {
      observer.current.disconnect();
      observer.current = null;
    }
    alertStartTime.current = null;

    // Callback function to handle pressure records
    function pressureCallback(_x) {
      return _pressureCallback.apply(this, arguments);
    }
    function _pressureCallback() {
      _pressureCallback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(records) {
        var _records$at;
        var pressureState, battery;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pressureState = (records === null || records === void 0 || (_records$at = records.at(-1)) === null || _records$at === void 0 ? void 0 : _records$at.state) || NOT_SUPPORTED;
              _context.next = 3;
              return getBatteryLevel();
            case 3:
              battery = _context.sent;
              _browserLogs.datadogLogs.logger['info']("Current pressure: ".concat(pressureState, ", Battery level: ").concat(battery), _objectSpread(_objectSpread({}, loggerContext), {}, {
                cpuPressureState: pressureState,
                battery: battery
              }));
              if (onProlongedHighCPUUsage) {
                handleProlongedHighCPUUsage(pressureState, alertStartTime, onProlongedHighCPUUsage);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _pressureCallback.apply(this, arguments);
    }
    function initObserver() {
      return _initObserver.apply(this, arguments);
    }
    function _initObserver() {
      _initObserver = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(typeof PressureObserver === 'undefined')) {
                _context2.next = 5;
                break;
              }
              _browserLogs.datadogLogs.logger['info']('PressureObserver is not supported.');
              _context2.next = 4;
              return pressureCallback([]);
            case 4:
              return _context2.abrupt("return");
            case 5:
              _context2.prev = 5;
              // eslint-disable-next-line no-undef
              observer.current = new PressureObserver(pressureCallback);
              _context2.next = 9;
              return observer.current.observe('cpu', {
                sampleInterval: SAMPLE_INTERVAL_MS
              });
            case 9:
              _context2.next = 16;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](5);
              _browserLogs.datadogLogs.logger['info']('Error setting up PressureObserver:', _context2.t0);
              _context2.next = 16;
              return pressureCallback([]);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[5, 11]]);
      }));
      return _initObserver.apply(this, arguments);
    }
    initObserver();
    return function () {
      if (observer.current) {
        observer.current.disconnect();
        alertStartTime.current = null;
        observer.current = null;
      }
    };
  }, [onProlongedHighCPUUsage]);
  return null;
};

/**
 * Gets the current battery level as a percentage or NOT_SUPPORTED string
 * @returns {Promise<number|string>} Battery level percentage or NOT_SUPPORTED
 */
var getBatteryLevel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var battery;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          if ('getBattery' in navigator) {
            _context3.next = 4;
            break;
          }
          _browserLogs.datadogLogs.logger['warn']('Battery level: not supported', loggerContext);
          return _context3.abrupt("return", NOT_SUPPORTED);
        case 4:
          _context3.next = 6;
          return navigator.getBattery();
        case 6:
          battery = _context3.sent;
          return _context3.abrupt("return", battery.level === null ? NOT_SUPPORTED : battery.level * 100);
        case 10:
          _context3.prev = 10;
          _context3.t0 = _context3["catch"](0);
          _browserLogs.datadogLogs.logger['error']('Error accessing battery information:', _context3.t0);
          return _context3.abrupt("return", NOT_SUPPORTED);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 10]]);
  }));
  return function getBatteryLevel() {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Manages alerting for prolonged high CPU pressure conditions.
 * Triggers a callback when high CPU pressure (serious/critical) persists
 * for longer than the defined threshold.
 *
 * @param {string} currentState - Current CPU pressure state ('nominal', 'fair', 'serious', 'critical', or 'not-supported')
 * @param {React.MutableRefObject<number|null>} alertStartRef - Reference to track when high CPU pressure started
 * @param {function} onProlongedHighCPUUsage - Callback function that receives the pressure state object when threshold is exceeded
 *
 */
var handleProlongedHighCPUUsage = function handleProlongedHighCPUUsage(currentState, alertStartRef, onProlongedHighCPUUsage) {
  var timeSinceLastAlert = Date.now() - alertStartRef.current;
  if (!alertStartRef.current) {
    alertStartRef.current = Date.now();
    return;
  }
  if (timeSinceLastAlert >= ALERT_THRESHOLD) {
    alertStartRef.current = null;
    if (HIGH_CPU_PRESSURE.includes(currentState)) {
      onProlongedHighCPUUsage({
        state: currentState
      });
    }
  }
};
var _default = exports["default"] = SystemHealthMonitor;